<template>
  <div class="bg-situational-lightgrey flex rounded-2xl p-1">
    <button
      type="button"
      class="flex-1 rounded-xl py-2.5 text-sm font-medium capitalize transition-colors duration-200"
      :class="isEconomyActive ? activeTabClass : inactiveTabClass"
      @click="
        emit('onTabChange', searchForm.config.CABIN_CLASSES.ECONOMY, false)
      "
    >
      {{ $t('general.cabinClass.economy') }}
    </button>
    <button
      type="button"
      class="flex-1 rounded-xl py-2.5 text-sm font-medium capitalize transition-colors duration-200"
      :class="isBusinessActive ? activeTabClass : inactiveTabClass"
      @click="
        emit('onTabChange', searchForm.config.CABIN_CLASSES.BUSINESS, false)
      "
    >
      {{ $t('general.cabinClass.business') }}
    </button>
    <button
      type="button"
      class="flex-1 rounded-xl py-2.5 text-sm font-medium capitalize transition-colors duration-200"
      :class="isYouthActive ? activeTabClass : inactiveTabClass"
      @click="
        emit('onTabChange', searchForm.config.CABIN_CLASSES.ECONOMY, true)
      "
    >
      {{ $t('general.cabinClass.youth') }}
    </button>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { searchForm } from 'shared';

  const props = defineProps<{
    activeTab: string;
    isYouth: boolean;
    source: string;
  }>();

  const emit = defineEmits<{
    (e: 'onTabChange', tabId: string, isYouth: boolean): void;
  }>();

  const activeTabClass =
    'bg-background-neutral-secondary text-text-neutral-primary shadow-sm';
  const inactiveTabClass = 'text-text-neutral-quaternary';

  const isEconomyActive = computed(
    () =>
      props.activeTab === searchForm.config.CABIN_CLASSES.ECONOMY &&
      !props.isYouth,
  );
  const isBusinessActive = computed(
    () => props.activeTab === searchForm.config.CABIN_CLASSES.BUSINESS,
  );
  const isYouthActive = computed(() => props.isYouth);
</script>
